import { AnyAction } from "redux";
import { SET_FINANCIAL_YEARS_LOADED } from "../actions/loadingFinancialYears";

export const loadingFinancialYears = (state = false, action: AnyAction) => {
  switch (action.type) {
    case SET_FINANCIAL_YEARS_LOADED:
      return action.financialYearsLoaded;
    default:
      return state;
  }
};

export default loadingFinancialYears;
